import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, Button, TextField, Alert } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setRegionDetailsData } from '../../../redux/regionDetailsDataSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/roles/updateRoleName.css';

export const UpdateRegion = ({ updateRegionOpen, setUpdateRegionOpen }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [errMsg, setErrMsg] = useState(null);
    const regionDetailsData = useSelector((state) => state?.RegionDetailsData);

    const formik = useFormik({
        initialValues: {
            name: regionDetailsData?.name || '',
            description: regionDetailsData?.description || '',
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required(t('isRequired')),
            description: Yup.string().optional(),
        }),
        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`region/${regionDetailsData.id}`, values);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setRegionDetailsData({ ...regionDetailsData, name: response.data.name, description: response.data.description }));
                    dispatch(setSuccessfullModifyDialog({ open: true, type: "Modifier le nom et la description de la region" }));
                    setUpdateRegionOpen(false);
                }
            } catch (error) {
                console.error('Error updating role name:', error);
                setErrMsg(error?.response?.data?.message || error.message || 'Erreur lors de la modification de la region');
            }
        },
    });

    const { handleSubmit, values, handleChange, handleBlur, touched, errors } = formik;

    return (
        <Dialog open={updateRegionOpen} fullWidth>
            <Box onClick={() => setUpdateRegionOpen(false)} className='updateRoleName_icon_text'>
                <Typography className='updateRoleName_title'>{t("Modifier le nom et la description de la region")}</Typography>
                <Iconify icon={"material-symbols:close"} className='updateRoleName_close_icon' />
            </Box>
            {errMsg && <Alert severity="error">{errMsg}</Alert>}
            <form onSubmit={handleSubmit}>
                <DialogContent className='updateRoleName_dialog_content' >
                    <Box className="updateRoleName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateRoleNameInputTitle">{t('Nom')}</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.name}
                            className='updateRoleName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="updateRoleName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateRoleNameInputTitle">{t('Description')} (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.description}
                            className='updateRoleName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="description"
                            error={touched.description && Boolean(errors.description)}
                            helperText={touched.description && errors.description}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='updateRoleName_dialog_actions'>
                    <Button className='updateRoleName_button_annuler' onClick={() => setUpdateRegionOpen(false)}>{t('Annuler')}</Button>
                    <Button className='updateRoleName_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};